module.exports = __webpack_public_path__ + "static/media/slide1.1894e3e3.webp";